<template>
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.1381 7.52867L10.4714 2.862C10.3457 2.74056 10.1773 2.67336 10.0025 2.67488C9.82768 2.6764 9.66048 2.74652 9.53687 2.87012C9.41326 2.99373 9.34315 3.16093 9.34163 3.33573C9.34011 3.51053 9.40731 3.67893 9.52875 3.80467L13.0574 7.33333H1.33341C1.1566 7.33333 0.987034 7.40357 0.86201 7.5286C0.736986 7.65362 0.666748 7.82319 0.666748 8C0.666748 8.17681 0.736986 8.34638 0.86201 8.4714C0.987034 8.59643 1.1566 8.66667 1.33341 8.66667H13.0574L9.52875 12.1953C9.46508 12.2568 9.41429 12.3304 9.37935 12.4117C9.34441 12.4931 9.32602 12.5805 9.32525 12.6691C9.32448 12.7576 9.34135 12.8454 9.37487 12.9273C9.40839 13.0092 9.45789 13.0837 9.52049 13.1463C9.58308 13.2089 9.65752 13.2584 9.73945 13.2919C9.82138 13.3254 9.90916 13.3423 9.99768 13.3415C10.0862 13.3407 10.1737 13.3223 10.255 13.2874C10.3364 13.2525 10.4099 13.2017 10.4714 13.138L15.1381 8.47133C15.2631 8.34631 15.3333 8.17678 15.3333 8C15.3333 7.82322 15.2631 7.65369 15.1381 7.52867Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps<{
        background?: string;
    }>();

    const background = computed(() => props.background || '#FFFFFF');
</script>

<style scoped></style>
